import { AxiosResponse, AxiosRequestConfig } from 'axios';
import client from 'api/client';

export interface ChecklistDocumentItem {
    /** int for template docs, null for legacy/default docs. */
    document_template_id: number | null;
    /** Canonical (English) name — used as the fallback selection key. */
    document_name: string;
    /** Already localized to the current user's language_setting. */
    name: string;
    /** Already localized to the current user's language_setting. */
    description: string;
    name_en?: string;
    name_fr?: string;
    description_en?: string;
    description_fr?: string;
    is_form: boolean;
    /** true => already attached to this application. */
    already_exists: boolean;
}

export interface DocumentChecklistResponse {
    document_checklist: ChecklistDocumentItem[];
}

export interface CreateChecklistDocument {
    document_template_id?: number;
    document_name?: string;
}

/** Generate a service checklist. Omit `documents` to create the entire list. */
export interface CreateServiceChecklistPayload {
    country: string;
    service_name: string;
    documents?: CreateChecklistDocument[];
}

/**
 * Add picked templates from catalog search. Do not send `country` or
 * `service_name` — those are only for generating a full service checklist.
 */
export interface CreatePickedDocumentsPayload {
    documents: CreateChecklistDocument[];
}

export type CreateChecklistPayload = CreateServiceChecklistPayload | CreatePickedDocumentsPayload;

export interface CreateChecklistResponse {
    created_count: number;
    created_document_names: string[];
}

export function get(
    applicationId: string | number,
    country: string,
    serviceName: string,
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<DocumentChecklistResponse>> {
    return client.get<DocumentChecklistResponse>(
        `/applications/${applicationId}/document-checklist`,
        {
            ...customConfig,
            params: {
                country,
                service_name: serviceName,
                ...(customConfig?.params || {}),
            },
        }
    );
}

export function post(
    applicationId: string | number,
    payload: CreateChecklistPayload,
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<CreateChecklistResponse>> {
    return client.post<CreateChecklistResponse>(
        `/applications/${applicationId}/document-checklist`,
        payload,
        customConfig
    );
}
